import React from 'react'
import { Paragraph } from '@scentregroup/ui'
import style from './index.module.scss'

const EmptyProduct: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <div className={style.emptyProductWrapper}>
      <Paragraph>No exact matches found</Paragraph>
      <Paragraph>
        Please change categories or remove filters to view more results
      </Paragraph>
    </div>
  )
}

export default EmptyProduct
